export class Bonus {
    constructor(scene) {
        this.scene = scene;
        this.bonusContainer = this.scene.add.container();
        this.timers = [];
        this.tweenInSpeed = 300;
    }

    init(callback) {
        this.callback = callback;

        if(this.scene.slots.spinStarted) {
            return;
        }

        this.startBonusAnimation();
    }

    reset() {
        for(const [ timerIndex, timer ] of Object.entries(this.timers)) {
            timer.remove();
            delete this.timers[timerIndex];
        }

        for (const sprite of this.bonusContainer.getAll()) {
            if(sprite.tween && sprite.tween.isPlaying()) {
                sprite.tween.remove();
            }

            if(sprite.anims) {
                if(sprite.anims.isPlaying) {
                    sprite.anims.pause();
                }
            }
        }

        this.scene.characterOverlay.alpha = 0;
        this.scene.character.bubble.alpha = 0;
        this.scene.character.text.alpha = 0;

        this.doCallback();
    }

    doCallback() {
        if(this.callback) {
            this.callback();
        }

        this.callback = undefined;
    }

    startBonusAnimation() {
        this.scene.characterOverlay.tween = this.scene.add.tween({ 
            targets: [this.scene.characterOverlay],
            alpha: 0.6,
            ease: 'Power0',
            duration: this.tweenInSpeed,
            yoyo: 0,
            repeat: 0
        });

        this.scene.sound.play('welcome');

        this.scene.character.bubble.tween = this.scene.add.tween({
            targets: [this.scene.character.bubble, this.scene.character.text],
            alpha: 1,
            ease: 'Power0',
            duration: this.tweenInSpeed,
            yoyo: 0,
            repeat: 0,
            onComplete: () => {
                let timer = this.scene.time.delayedCall(3000, () => {
                    this.reset();
                }, {}, this);
                
                this.timers.push(timer);
            },
        });
    }

    playBonusText() {
        this.scene.showWinning('BONUS', () => {
            this.reset();
        });
    }
}